module.exports = __webpack_public_path__ + "media/stylesheets/images/main/bell-x3-0b1b35603a7d2d7830391048ab120116.png";